// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"410":"8dbde168","842":"b804c6ca"}[chunkId] + ".chunk.js";
};